import cn from 'classnames';
import { FC } from 'react';
import { Control, Controller } from 'react-hook-form';

import { Input } from '@/shared/ui';

import { AdditionalInfoFormPayload } from '../../config/types';
import styles from '../../Steps.module.scss';

type CompanyNameStepProps = {
  control: Control<AdditionalInfoFormPayload>;
  className?: string;
  testID?: string;
};

export const CompanyNameStep: FC<CompanyNameStepProps> = (props) => {
  const { control, className, testID } = props;

  return (
    <div
      className={cn(styles.container, className)}
      data-testid={testID}
      data-component="company-name-step"
    >
      <Controller
        control={control}
        name="CompanyName"
        render={({
          field: { ref, value, name, onBlur, onChange },
          fieldState: { error },
        }) => (
          <Input
            ref={ref}
            value={value}
            name={name}
            onBlur={onBlur}
            onChange={onChange}
            required
            error={error?.message}
          />
        )}
      />
    </div>
  );
};
